<template>
  <v-card class="chatRecord" flat>

    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getChatrooms" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>{{ user == 'seller' ? '主播' : '會員' }}</v-col>
        <v-col style="min-width: 100px; max-width: 100px"></v-col>
      </v-row>

      <div class="table-body">
        <v-row 
          class="table-content" 
          no-gutters 
          v-for="chatroom in chatrooms" 
          :key="chatroom.id"
          @click="$refs.viewRecord.open(chatroom)"
        >
          <v-col>
            <v-avatar size="40" class="mr-2">
              <v-img :src="$HOST_URL + chatroom[user].usericon"/>
            </v-avatar>
              {{ chatroom[user].nickname }}
          </v-col>
        </v-row>
      </div>
    </div>
    <ViewRecord ref="viewRecord"></ViewRecord>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdminToolbar from '@/components/admin/AdminToolbar'
import ViewRecord from '@/components/admin/chat/ViewRecord'
export default {
  components: { AdminToolbar, ViewRecord },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '主播ID', value: 'seller' },
        { text: '會員ID', value: 'member' },
      ],
      sortTypes: [
        { text: '建立日期' },
      ],
      sort: '',
      tabs: [],
      tab: 0,
      search_condition: [],
      chatrooms: []
    }
  },
  computed: {
    user() {
      return this.search_condition.length > 0 && this.search_condition[0].value == 'seller' ? 'member' : 'seller'
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.chatrooms = []
      this.getChatrooms()
    },
    getChatrooms() {
      if(this.search_condition.length == 0) {
        return
      }
      this.busy = true
      let url = `/admin/${this.search_condition[0].value}/${this.search_condition[0].keyword}/chat`
      this.axios(url).then(response => {
        this.chatrooms = this.chatrooms.concat(response.data)
      })
    },
  }
}
</script>

<style lang="scss">
.chatRecord {
  .table-content {
    @extend .pointer;
    &:hover {
      background: lightgrey;
    }
  }
}
</style>